import React, { Component } from "react";
import { Col, Row, Button, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";
import moment from "moment-timezone";

import classes from "./BackdatePlaceholderForm.module.scss";
import Form from "../../../general/Form/Form";
import { boxiPrimary } from "../../../../assets/style/colors";

const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

const initialState = {
  campaignId: null,
  startDate: null,
  endDate: null,
  campaignList: [],
  error: false,
  disable: false
};

class BackdatePlaceholderForm extends Component {
  state = initialState;

  onFormSubmitHandler = async (e) => {
    e.preventDefault();
    this.setState({
      error: false
    });
    if (this.state.campaignId && this.state.startDate && this.state.endDate) {
      try {
        let url = `${process.env.REACT_APP_API_HOST}/generate/campaign/placeholders?campaign_id=${this.state.campaignId}&start=${this.state.startDate}&end=${this.state.endDate}`;
        let res = await axios.get(url, { withCredentials: true });
        if (res.status === 200) {
          window.location.reload();
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      this.setState({
        error: true
      });
    }
  };

  componentDidMount = () => {
    this.checkRunningProcess();
    window.setTimeout(this.loadCampaigns(), 150);
    this.checkValidTime();
  };

  checkRunningProcess = async () => {
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/generate/processes`, { withCredentials: true });
      if (res.status === 200 && res.data.processes.length > 0) {
        this.setState({
          disable: true
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  loadCampaigns = async () => {
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/campaign`, { withCredentials: true });
      if (res.status === 200) {
        let campaigns = res.data.active_campaigns
          .map((campaign) => ({ name: campaign.name, id: campaign.campaign_id }))
          .sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          })
          .map((campaign) => (
            <option key={campaign.id} value={campaign.id}>
              {campaign.name}
            </option>
          ));
        this.setState({
          campaignList: campaigns
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  checkValidTime = () => {
    let date = moment().tz("America/Los_Angeles");
    // date = moment("2020-08-30 2:05");
    if (date.hour() % 2 === 0 && date.minute() < 15) {
      console.log("disable");
      this.setState({
        disable: true
      });
    }
  };

  render() {
    return (
      <Form title="Backdate Campaign Placeholder Truck Routes">
        <Row form className="pl-4 pr-4 mt-4">
          <Col xs={4}>
            <FormGroup>
              <Label>Campaign</Label>
              <Input
                type="select"
                onChange={this.campaignIdChangeHandler}
                value={this.state.campaignId ? this.state.campaignId : ""}
              >
                <option>-- Select a Campaign --</option>
                {this.state.campaignList}
              </Input>
            </FormGroup>
          </Col>
          <Col xs={4}>
            <FormGroup>
              <Label>Start Date (Inclusive)</Label>
              <Input
                type="date"
                onChange={this.startDateChangeHandler}
                value={this.state.startDate ? this.state.startDate : ""}
              />
            </FormGroup>
          </Col>
          <Col xs={4}>
            <FormGroup>
              <Label>End Date (Exclusive)</Label>
              <Input type="date" onChange={this.endDateChangeHandler} value={this.state.endDate ? this.state.endDate : ""} />
            </FormGroup>
          </Col>
        </Row>
        {this.state.error ? (
          <Row form className="pl-5 pr-5 mt-1 pb-1">
            <Col className="text-danger">All fields must have a value</Col>
          </Row>
        ) : null}
        <Row form className="pl-5 pr-5 mt-4 pb-4">
          <Col>
            <Button style={{ width: "100px", backgroundColor: boxiPrimary, borderColor: boxiPrimary }} onClick={this.onFormSubmitHandler}>
              Start
            </Button>
          </Col>
        </Row>
        {this.state.disable ? (
          <div className={classes.disableOverlay}>
            A Route Generation Is Already In Process...
            <br />
            Please Wait...
          </div>
        ) : null}
      </Form>
    );
  }

  campaignIdChangeHandler = (e) => {
    this.setState({
      campaignId: parseInt(e.target.value)
    });
  };

  startDateChangeHandler = (e) => {
    this.setState({
      startDate: e.target.value
    });
  };

  endDateChangeHandler = (e) => {
    this.setState({
      endDate: e.target.value
    });
  };
}

export default BackdatePlaceholderForm;
